import { Link, useLocation } from "react-router-dom";
import { Gift } from "lucide-react";

export const FloatingFreePassButton = () => {
  const location = useLocation();
  const pathname = location.pathname;

  // Hide on the free-pass page and thank-you page
  if (pathname === "/free-pass" || pathname === "/thank-you-3-day-guest-pass") {
    return null;
  }

  return (
    <Link
      to="/free-pass"
      className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-40 flex items-center gap-2 rounded-full bg-brand-pink px-4 md:px-5 py-2.5 md:py-3 text-white font-bold uppercase tracking-wider shadow-lg hover:bg-brand-pink-hover hover:shadow-xl transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-brand-pink focus:ring-offset-2"
      data-testid="floating-free-pass-button"
      aria-label="Request 1 Day Free Pass"
    >
      <Gift className="w-5 h-5 flex-shrink-0" />
      <span className="text-sm whitespace-nowrap">1 Day Free Pass</span>
    </Link>
  );
};

export default FloatingFreePassButton;
